(function () {
  'use strict';

  var STORAGE_KEY = 'bsc-graded-coin-enquiry-v1';
  var STEP_NAMES = ['intent', 'details', 'contact', 'review'];
  var ATTRIBUTION_KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_campaign', 'utm_term', 'utm_content', 'utm_source', 'utm_medium'];
  var ATTRIBUTION_FIELDS = [
    'contact[Google click ID]',
    'contact[Google braided click ID]',
    'contact[Web braided click ID]',
    'contact[Campaign]',
    'contact[Keyword]',
    'contact[Advert]',
    'contact[Marketing source]',
    'contact[Marketing medium]'
  ];
  var SUCCESS_MARKUP = '<span class="bsc-success__mark" aria-hidden="true">✓</span><h2>Many thanks for your enquiry.</h2><p>We receive a high number of enquiries, so it may take the team a little time to respond.</p><p>If you would like to speak to someone sooner, please call us on 0800 107 5135.</p><a class="bsc-button bsc-success__phone" href="tel:08001075135">Call 0800 107 5135</a>';

  function track(eventName, values) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName, form_name: 'graded_coin_owner_enquiry' }, values || {}));
  }

  function trackGoogleAdsLead(intent) {
    var labels = {
      'Buy': '_Cp0CI-c5N0cEMzC64ED',
      'Sell': '5FCvCJKc5N0cEMzC64ED',
      'Trade': 'qkiDCJWc5N0cEMzC64ED',
      'Get a second opinion': 'dldNCJic5N0cEMzC64ED',
      'Something else': '0500CJuc5N0cEMzC64ED'
    };

    if (labels[intent] && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-809165132/' + labels[intent],
        value: 1,
        currency: 'GBP'
      });
    }
  }

  function init(form) {
    var panels = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
    if (!panels.length) {
      if (form.querySelector('[data-success-state]')) {
        try {
          var submittedValues = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
          var confirmedIntent = submittedValues['contact[I would like to]'] || '';
          form.querySelector('[data-success-state]').innerHTML = SUCCESS_MARKUP;
          if (confirmedIntent) {
            track('lead_confirmed', {
              lead_intent: confirmedIntent,
              conversion_source: 'shopify_contact_success'
            });
            trackGoogleAdsLead(confirmedIntent);
          }
          window.sessionStorage.removeItem(STORAGE_KEY);
        } catch (error) {}
      }
      return;
    }

    var isPreview = form.hasAttribute('data-preview');
    var currentIndex = 0;
    var started = false;
    var progress = form.querySelector('[data-progress]');
    var progressBar = form.querySelector('[data-progress-bar]');
    var currentStepText = form.querySelector('[data-current-step]');
    var backButton = form.querySelector('[data-back]');
    var nextButton = form.querySelector('[data-next]');
    var submitButton = form.querySelector('[data-submit]');
    var status = form.querySelector('[data-form-status]');
    var summaryField = form.querySelector('[data-summary-field]');

    function applyAttribution() {
      var params = new URLSearchParams(window.location.search);
      form.querySelectorAll('[data-attribution]').forEach(function (field) {
        var key = field.getAttribute('data-attribution');
        var current = params.get(key);
        if (current) field.value = current.slice(0, 500);
      });
      ATTRIBUTION_KEYS.forEach(function (key) {
        var current = params.get(key);
        if (!current) return;
        try { window.sessionStorage.setItem('bsc-attribution-' + key, current.slice(0, 500)); } catch (error) {}
      });
      form.querySelectorAll('[data-attribution]').forEach(function (field) {
        if (field.value) return;
        try { field.value = window.sessionStorage.getItem('bsc-attribution-' + field.getAttribute('data-attribution')) || ''; } catch (error) {}
      });
    }

    function applyIntentParameter() {
      var requested = (new URLSearchParams(window.location.search).get('intent') || '').toLowerCase();
      var intentMap = {
        buy: 'Buy',
        sell: 'Sell',
        trade: 'Trade',
        valuation: 'Get a second opinion',
        'second-opinion': 'Get a second opinion',
        other: 'Something else'
      };
      var value = intentMap[requested];
      if (!value) return;
      var field = form.querySelector('[data-intent][value="' + value + '"]');
      if (field) field.checked = true;
    }

    function announce(message) {
      status.textContent = '';
      window.setTimeout(function () { status.textContent = message; }, 10);
    }

    function selectedIntent() {
      var checked = form.querySelector('[data-intent]:checked');
      return checked ? checked.value : '';
    }

    function updateIntentSections() {
      var intent = selectedIntent();
      form.querySelectorAll('[data-intent-section]').forEach(function (section) {
        var active = section.getAttribute('data-intent-section') === intent;
        section.hidden = !active;
        section.querySelectorAll('input, select, textarea').forEach(function (field) {
          field.disabled = !active;
        });
      });
      var legend = form.querySelector('[data-details-legend]');
      var intro = form.querySelector('[data-details-intro]');
var wording = {
  'Buy': ['What are you looking for?', 'If you have a particular coin in mind, add any details you know.'],
  'Sell': ['Tell us what you may sell', 'Grading and certificate details are helpful, but you can still continue without them.'],
  'Trade': ['Tell us about the trade', 'Add any details you know about what you have and what you might like instead.'],
  'Get a second opinion': ['What would you like us to look at?', 'Add any details you have about the coin, offer or decision.'],
  'Something else': ['How can BSC help?', 'You can add a few details here if you would like to.']
};
      if (wording[intent]) {
        legend.textContent = wording[intent][0];
        intro.textContent = wording[intent][1];
      }
    }

    function clearErrors(panel) {
      panel.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
        field.removeAttribute('aria-invalid');
      });
      var target = form.querySelector('[data-error-for="' + panel.getAttribute('data-step') + '"]');
      if (target) target.textContent = '';
    }

    function validatePanel(panel, moveFocus) {
      clearErrors(panel);
      var invalid = [];
      var step = panel.getAttribute('data-step');

      if (step === 'intent' && !selectedIntent()) {
        invalid.push(form.querySelector('[data-intent]'));
      }

      panel.querySelectorAll('[required]:not(:disabled), [data-required-when-visible]:not(:disabled)').forEach(function (field) {
        var missing = false;
        if (field.type === 'radio') {
          missing = !form.querySelector('input[name="' + field.name.replace(/"/g, '\\"') + '"]:checked');
        } else if (field.type === 'checkbox') {
          missing = !field.checked;
        } else {
          missing = !field.value.trim() || !field.checkValidity();
        }
        if (missing && invalid.indexOf(field) === -1) invalid.push(field);
      });

      if (invalid.length) {
        invalid.forEach(function (field) { field.setAttribute('aria-invalid', 'true'); });
        var errorTarget = form.querySelector('[data-error-for="' + step + '"]');
        var message = step === 'intent' ? 'Choose what you would like to do.' : step === 'review' ? 'Please confirm that BSC can contact you.' : 'Please complete the highlighted fields.';
        if (errorTarget) errorTarget.textContent = message;
        announce(message);
        if (moveFocus !== false) invalid[0].focus();
        return false;
      }
      return true;
    }

    function save() {
      var values = {};
      new FormData(form).forEach(function (value, key) {
        if (key.indexOf('contact[') === 0 && key !== 'contact[Consent]' && key !== 'contact[Journey summary]') values[key] = value;
      });
      try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values)); } catch (error) {}
    }

    function restore() {
      var values;
      try { values = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}'); } catch (error) { values = {}; }
      Object.keys(values).forEach(function (name) {
        var fields = form.querySelectorAll('[name="' + name.replace(/"/g, '\\"') + '"]');
        fields.forEach(function (field) {
          if (field.type === 'radio' || field.type === 'checkbox') field.checked = field.value === values[name];
          else if (!field.value) field.value = values[name];
        });
      });
      applyAttribution();
      applyIntentParameter();
      updateIntentSections();
    }

    function reviewRows() {
      var rows = [];
      var skip = ['form_type', 'utf8', 'contact[Enquiry source]', 'contact[Journey summary]', 'contact[Consent]'].concat(ATTRIBUTION_FIELDS);
      new FormData(form).forEach(function (value, key) {
        if (!value || skip.indexOf(key) !== -1) return;
        var field = form.querySelector('[name="' + key.replace(/"/g, '\\"') + '"]');
        if (!field || field.disabled) return;
        var label = key.replace(/^contact\[/, '').replace(/\]$/, '');
        if (label === 'name') label = 'Name';
        if (label === 'email') label = 'Email';
        if (label === 'phone') label = 'Telephone';
        rows.push([label, value]);
      });
      return rows;
    }

    function buildReview() {
      var review = form.querySelector('[data-review]');
      var rows = reviewRows();
      review.textContent = '';
      rows.forEach(function (row) {
        var wrap = document.createElement('div');
        var term = document.createElement('dt');
        var description = document.createElement('dd');
        wrap.className = 'bsc-review__row';
        term.textContent = row[0];
        description.textContent = row[1];
        wrap.appendChild(term);
        wrap.appendChild(description);
        review.appendChild(wrap);
      });
      summaryField.value = rows.map(function (row) { return row[0] + ': ' + row[1]; }).join(' | ');
    }

    function showStep(index, focusPanel) {
      currentIndex = Math.max(0, Math.min(index, panels.length - 1));
      panels.forEach(function (panel, panelIndex) { panel.hidden = panelIndex !== currentIndex; });
      var number = currentIndex + 1;
      currentStepText.textContent = number;
      progress.setAttribute('aria-valuenow', number);
      progressBar.style.width = ((number / panels.length) * 100) + '%';
      backButton.hidden = currentIndex === 0;
      nextButton.hidden = currentIndex === panels.length - 1;
      submitButton.hidden = currentIndex !== panels.length - 1;
      var nextLabels = ['Tell us more', 'Add contact details', 'Check my details'];
      if (!nextButton.hidden) nextButton.textContent = nextLabels[currentIndex] || 'Continue';
      if (panels[currentIndex].getAttribute('data-step') === 'review') buildReview();
      track('prequal_step', { step_number: number, step_name: STEP_NAMES[currentIndex], lead_intent: selectedIntent() });
      announce('Step ' + number + ' of ' + panels.length + ': ' + (panels[currentIndex].querySelector('legend, h2') || {}).textContent);
      if (focusPanel) {
        var heading = panels[currentIndex].querySelector('legend, h2');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      }
    }

    form.addEventListener('focusin', function () {
      if (!started) { started = true; track('form_start'); }
    }, { once: true });

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-intent]')) {
        updateIntentSections();
        track('lead_intent', { lead_intent: event.target.value });
      }
      event.target.removeAttribute('aria-invalid');
      save();
    });
    form.addEventListener('input', save);

    nextButton.addEventListener('click', function () {
      if (!validatePanel(panels[currentIndex])) return;
      save();
      showStep(currentIndex + 1, true);
    });
    backButton.addEventListener('click', function () { showStep(currentIndex - 1, true); });

    form.addEventListener('submit', function (event) {
      var invalidIndex = -1;
      for (var index = 0; index < panels.length; index += 1) {
        if (!validatePanel(panels[index], false)) {
          invalidIndex = index;
          break;
        }
      }
      if (invalidIndex !== -1) {
        event.preventDefault();
        showStep(invalidIndex, false);
        var firstInvalid = panels[invalidIndex].querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
        return;
      }
      buildReview();
      save();
      track('lead_submit', { lead_intent: selectedIntent(), preferred_contact: (form.querySelector('[name="contact[Preferred contact]"]:checked') || {}).value || '' });
      if (isPreview) {
        event.preventDefault();
        form.innerHTML = '<section class="bsc-success" tabindex="-1">' + SUCCESS_MARKUP + '</section>';
        form.querySelector('.bsc-success').focus();
        try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) {}
      }
    });

    restore();
    showStep(0, false);
    if (form.querySelector('[data-server-errors]')) form.querySelector('[data-server-errors]').focus();
  }

  function initHeader(header) {
    var menuButton = header.querySelector('.bsc-mobile-control');
    var searchButton = header.querySelector('.bsc-mobile-search');
    var navigation = header.querySelector('.bsc-main-nav');
    var search = header.querySelector('.bsc-search');

    function setOpen(button, panel, open, openLabel, closedLabel) {
      if (!button || !panel) return;
      panel.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', open ? openLabel : closedLabel);
    }

    if (menuButton && navigation) {
      menuButton.addEventListener('click', function () {
        var open = menuButton.getAttribute('aria-expanded') !== 'true';
        setOpen(menuButton, navigation, open, 'Close menu', 'Open menu');
        setOpen(searchButton, search, false, 'Close search', 'Open search');
      });
    }

    if (searchButton && search) {
      searchButton.addEventListener('click', function () {
        var open = searchButton.getAttribute('aria-expanded') !== 'true';
        setOpen(searchButton, search, open, 'Close search', 'Open search');
        setOpen(menuButton, navigation, false, 'Close menu', 'Open menu');
        if (open) {
          var field = search.querySelector('input[type="search"]');
          if (field) field.focus();
        }
      });
    }

    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setOpen(menuButton, navigation, false, 'Close menu', 'Open menu');
      setOpen(searchButton, search, false, 'Close search', 'Open search');
    });
  }

  function initReviewCarousel(carousel) {
    var section = carousel.closest('.bsc-reviews');
    var previous = section && section.querySelector('[data-review-prev]');
    var next = section && section.querySelector('[data-review-next]');
    var firstCard = carousel.querySelector('.bsc-review-card');
    if (!firstCard || !previous || !next) return;

    function move(direction) {
      var track = carousel.querySelector('.bsc-review-track');
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var distance = firstCard.getBoundingClientRect().width + gap;
      var maximum = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      var target = carousel.scrollLeft + (distance * direction);
      if (direction > 0 && carousel.scrollLeft >= maximum - 4) target = 0;
      if (direction < 0 && carousel.scrollLeft <= 4) target = maximum;
      carousel.scrollTo({ left: target, behavior: 'smooth' });
    }

    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    carousel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bsc-site-head').forEach(initHeader);
    document.querySelectorAll('[data-review-carousel]').forEach(initReviewCarousel);
    document.querySelectorAll('.bsc-prequal').forEach(init);
  });
}());
